export type Actions = "INIT" | "TO_LINK" | "CREATE_NEW_RESUME" | "SAVE_TO_DB";

export const postToParent = (action: Actions, payload?: unknown) => {
  window.parent.postMessage({ type: action, payload: payload }, "*");
};
